const degreesToRadianConversionValue = Math.PI / 180;

export function convertDegreesToRadian(value) {
  return value * degreesToRadianConversionValue;
}
